import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-navy-soft py-16 sm:py-20" aria-labelledby="results-title" data-id="element-164" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-165" data-mp="28ddg15bty3om">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-166" data-mp="2d6zu91xn6fmj">
          What educators using this teacher ready say
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-167" data-mp="2m6cwpancm3xr">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-gold/30 bg-steel p-6 shadow-lg shadow-black/20 ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-168" data-mp="2r70woltk1v44" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-mineral" aria-hidden="true" data-id="element-169" data-mp="3nf90gitpxk8j" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-170" data-mp="3ilej3m1l5hcm">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-171" data-mp="3dljxny0kxjyy">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-gold/50 bg-navy text-sm font-extrabold text-mineral" data-id="element-172" data-mp="38mgp43le4vm8">
                  {initials}
                </span>
                <span data-id="element-173" data-mp="5608ba314lp6">
                  <b className="block text-sm text-white" data-id="element-174" data-mp="870ydpzplnb">{name}</b>
                  <small className="text-xs text-muted" data-id="element-175" data-mp="akv8kcuittt">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}